import {
  Component,
  Input,
} from '@angular/core';
import {ReportUserGenerated} from "../../../../core/model-store/models/report-user-generated";

@Component({
    selector: 'procedure-report',
    templateUrl: './procedure-report.component.html',
    styleUrls: ['./procedure-report.component.css'],
    standalone: false
})
export class ProcedureReportComponent {

  @Input() reportTemplate: ReportUserGenerated;
  @Input() extractedArtifacts: any;
  @Input() viewOptionsCheckboxValues: any;
  @Input() preview: boolean = false;
}
